module.exports = __webpack_public_path__ + "img/17_1901_ah_house.78428f0c.jpg";